'use client';

import { useEffect } from 'react';

import Script from 'next/script';

import { HUBSPOT_PORTAL_ID } from '@config/constants';
import {
  OSANO_COOKIE_ACCEPTED,
  useCookiePermissions,
} from '@domain/cookies/CookiePermissionsContext';

export const HubSpot = () => {
  const { permissions } = useCookiePermissions();

  useEffect(() => {
    window._hsp = window._hsp ?? [];
    window._hsp.push([
      'setHubSpotConsent',
      {
        analytics: permissions.ANALYTICS === OSANO_COOKIE_ACCEPTED,
        advertisement: permissions.MARKETING === OSANO_COOKIE_ACCEPTED,
        functionality: permissions.PERSONALIZATION === OSANO_COOKIE_ACCEPTED,
      },
    ]);
  }, [permissions]);

  return (
    <Script
      id="hs-script-loader"
      strategy="afterInteractive"
      src={`https://js.hs-scripts.com/${HUBSPOT_PORTAL_ID}.js`}
    />
  );
};
